import { EJQuickLinks } from '../../../../constants/cimsPage/instances/ej'
import { QuickLinks } from '../../common'

const quickLinks = QuickLinks({
  page: EJQuickLinks,
  create: '24BE8C2C-2F49-4524-BB9B-401A1FB57428',
  view: '8A1656D7-3B29-4293-BC21-94350F6AFAAA',
  edit: '0814667C-2CA3-4F04-8DE6-EDC43EB882C9',
  removeRestore: '74496B1F-2136-4CD5-9195-AC753529EA34',
})

export const CreateEJQuickLink = quickLinks.Create
export const ViewEJQuickLink = quickLinks.View
export const EditEJQuickLink = quickLinks.Edit
export const RemoveRestoreEJQuickLink = quickLinks.RemoveRestore

export type EJQuickLinkPermission =
  | typeof CreateEJQuickLink
  | typeof ViewEJQuickLink
  | typeof EditEJQuickLink
  | typeof RemoveRestoreEJQuickLink
